import { Link } from 'gatsby'
import React, {useState } from 'react'
import { AnimatePresence } from 'framer-motion';
import SubNav from '~/components/SubNav';
import chevronUpWhite from '~/icons/chevron-up-white.svg';
import renderLink from '~/utils/render-link';
export default function MobileNavItem({ item, active, setActive }) {
  return (
    <div
      className="relative"
      onClick={() => item.subnav && setActive(active === item.title ? ' ': item.title)}>
      <Link
        to={renderLink(item.url)}
        className={`flex text-24px font-bold border-b border-light-grey py-5`}
        activeClassName={`text-blue`}
      >
        <span>{item.title}</span>

        <button className="ml-auto">
          <div className="w-8 h-8  bg-black rounded-full flex justify-center items-center">
            <img src={chevronUpWhite} className={`transform transition-transform ${item.subnav ? 'rotate-[180deg] ml-0': 'ml-1 rotate-90'} ${active === item.title ? 'rotate-[0deg]': 'ml-1 rotate-90'}`} alt="" />
          </div>
        </button>
      </Link>

      {/* Subnav */}
      {item.subnav && (
        <AnimatePresence>
          {active === item.title && <SubNav subnavName={item.title} {...item.subnav} />}
        </AnimatePresence>
      )}
    </div>
  )
}
